import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroBanner from './components/HeroBanner';
import CategoryNav from './components/CategoryNav';
import MovieSection from './components/MovieSection';
import WhyChooseUs from './components/WhyChooseUs';
import CTASection from './components/CTASection';
import { hotMovies, newMovies, moviesByCategory } from '@/mocks/movies';

export default function Home() {
  const topRatedMovies = [...hotMovies].sort((a, b) => b.rating - a.rating).slice(0, 6);

  useEffect(() => {
    document.title = '蘑菇影视 - 高清超清免费在线观看 | 4K蓝光无广告不缓冲电影电视剧';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', '蘑菇影视聚集高清、超清、4K、蓝光画质影视资源，免费在线观看，无广告干扰，播放流畅不缓冲，享受极致观影体验。');
    }
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', '蘑菇影视,高清免费,超清在线,4K电影,蓝光电视剧,无广告不缓冲,免费观看,高清影视,在线播放,流畅观影');
    }
  }, []);

  const webPageSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '蘑菇影视 - 高清超清免费在线观看',
    description: '蘑菇影视聚集高清、超清、4K、蓝光画质影视资源，免费在线观看，无广告干扰，播放流畅不缓冲，享受极致观影体验。',
    url: 'https://www.mogumovie.com/',
    about: {
      '@type': 'Organization',
      name: '蘑菇影视',
    },
  };

  return (
    <>
      <ScrollToTop />
      <script type="application/ld+json">
        {JSON.stringify(webPageSchema)}
      </script>
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroBanner />
          <CategoryNav />
          <MovieSection
            title="热门推荐"
            subtitle="全网热播，精彩不容错过"
            movies={hotMovies}
            viewAllLink="/category/all"
            viewAllLabel="查看全部热门"
          />
          <MovieSection
            title="最新上线"
            subtitle="第一时间为你呈现最新影视资源"
            movies={newMovies}
            viewAllLink="/category/all"
            viewAllLabel="查看全部新片"
          />
          <WhyChooseUs />
          <MovieSection
            title="高分佳作"
            subtitle="口碑爆棚，评分最高的精选影视"
            movies={topRatedMovies}
            viewAllLink="/category/all"
            viewAllLabel="查看全部高分"
          />
          <CTASection />
        </main>
        <Footer />
      </div>
    </>
  );
}